module.exports = __webpack_public_path__ + "images/backgrounds/fall/full.72c32b15d265b78e7058.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/backgrounds/fall/full.jpg
// module id = dem0
// module chunks = 13